// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#donation-success-icon[data-v-761ccc96]{color:#356b35;background-color:#fff;border-radius:100%}", ""]);
// Exports
module.exports = exports;
